// vue-i18n 实例：Composition API 模式（legacy: false）
// 语言切换统一由路由守卫按 URL 驱动（见 src/router/index.js）
import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

export const LOCALE_ZH = 'zh-CN'
export const LOCALE_EN = 'en-US'

const i18n = createI18n({
  legacy: false,          // Composition API 模式
  globalInjection: true,  // 模板中可直接使用 $t
  locale: LOCALE_ZH,      // 默认中文
  fallbackLocale: LOCALE_ZH,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
